'use strict';

angular.module('common.services', [])

.factory('AlertService', function($ionicPopup, projectTag, LocalStorageService, UserAccountManagementFactory) {
    "ngInject";

    var api = {
        alert: function(titleIn,templateIn) {
            var alertPopup = $ionicPopup.alert({
                title: titleIn,
                template: templateIn
            });
            alertPopup;
            
            var userIn = LocalStorageService.get('user');
            var memberDataIn = LocalStorageService.get('memberData');
            var val = {alert: templateIn, date:new Date().toISOString()};
            if (userIn)
            {
                val.user = userIn;
                firebase.database().ref("projectData/" + projectTag + "/publicWriteOnly/appAlertsByMember/" + userIn.uid).set(val);
            }
            else
            {
                val.signUpData = UserAccountManagementFactory.signUpData;
                firebase.database().ref("projectData/" + projectTag + "/publicWriteOnly/appAlerts/").push(val);                
            }
        }
    }
    return api;
})

.factory('LocalStorageService', function($q) {
    "ngInject";

    var api = {
    		
    		set: function(key,val) {
    			console.log("storing: "+key);
    			console.log(val);
    			localStorage.setItem(key, JSON.stringify(val));
    		},

		    get: function(key) {
    			return JSON.parse(localStorage.getItem(key));
        	}

  	}

  	return api;
})

.factory('CustomisationService', ['projectTag', '$rootScope', 'LocalStorageService', '$timeout', function(projectTag, $rootScope, LocalStorageService, $timeout) {
    "ngInject";

    var customisationDataUpdatedEvent = "customisationDataUpdatedEvent";

    var customisationsCss = ".button.button-positive {background-color: $primaryColour;}\
\
        .main-nav-bar {\
              border-color: $primaryColour;\
              background: url(\"$logoUrl\");\
              background-size: 40px 30px;\
              background-repeat: no-repeat;\
              background-position: center;\
              background-color: $primaryColour;\
              color:black;\
        }\
\
        .unionMembershipApp ion-content {\
            background: url(\"$signupBackgroundImage\") center center;\
            background-size: cover;\
        }\
\
        .newMemberSignup ion-content, .newMemberSignup2 ion-content, .existingMemberSignup ion-content, .verifyEmailAccount ion-content {\
                background: url(\"$signupBackgroundImage\") center center;\
                background-size: cover;\
        }        \
h1 {\
color:$secondaryColour !important; \
opacity:0.5 !important;\
}\
.button {\
color:white !important;\
font-color:secondaryColour !important;\
}\
.back-button {\
color:$secondaryColour !important;\
}\
input {\
color:$secondaryColour !important;\
}\
::-webkit-input-placeholder {\
   color: $secondaryColour !important;\
}\
:-moz-placeholder { /* Firefox 18- */\
   color: $secondaryColour !important;  \
}\
::-moz-placeholder {  /* Firefox 19+ */\
   color: $secondaryColour !important;  \
}\
:-ms-input-placeholder {  \
   color: $secondaryColour !important;  \
}\
\
body > ion-nav-view > ion-view > ion-content {\
background-color: $primaryColour !important;\
}\
body > ion-nav-bar > div:nth-child(3) > ion-header-bar > button {\
color:white !important;\
\
}\
ion-content {\
    background: $primaryColour !important;\
}\
\
\
    ";

    var customisations = {

        over18 : 
        {
            name: "over18", value: false, defaultValue: false
        },

        moreDetails : 
        {
            name: "moreDetails", value: false, defaultValue: false,
        },

        logoUrl :
        {
            name: "logoUrl",
            value: "img/user_account_management/img/8selJTDeQUuL1NyMAmDh_logo.png",
            defaultValue: "img/user_account_management/img/8selJTDeQUuL1NyMAmDh_logo.png",
        },

        primaryColour :
        {
            name: "primaryColour",
            value: '#352525',
            defaultValue: "#352525",
        },

        secondaryColour :
        {
            name: "secondaryColour",
            value: '#ffffff',
            defaultValue: "#ffffff",
        },

        navBar :
        {
            name: 'navBar',
            value: 'img/user_account_management/img/8selJTDeQUuL1NyMAmDh_logo.png',
            defaultValue: "img/user_account_management/img/8selJTDeQUuL1NyMAmDh_logo.png",
        },

        signupBackgroundImage :
        {
            name: 'signupBackgroundImage',
            value: 'img/user_account_management/img/backgroundImage.jpg',
            defaultValue: "img/user_account_management/img/backgroundImage.jpg",
        },

        membershipCardFrontHTML :
        {
            name: 'membershipCardFrontHTML',
            value: '<p>{{member.FirstName}} {{member.LastName}}<br />\n{{member.MembershipType}}</p>\n\n<p>Balance ${{member.AccountAvailableBalance/100}}</p>\n',
            defaultValue: '<p>{{member.FirstName}} {{member.LastName}}<br />\n{{member.MembershipType}}</p>\n\n<p>Balance ${{member.AccountAvailableBalance/100}}</p>\n',            
        },

        membershipCardBackHTML :
        {
            name: 'membershipCardBackHTML',
            value: '<h3>{{member.FirstName}}&nbsp; {{member.LastName}}</h3>\n\n<p>{{member.MembershipType}}</p>\n\n<p>{{member.PointsBalance}} Points</p>\n\n<p>Member ID {{member.Id}}</p>',
            defaultValue: '<h3>{{member.FirstName}}&nbsp; {{member.LastName}}</h3>\n\n<p>{{member.MembershipType}}</p>\n\n<p>{{member.PointsBalance}} Points</p>\n\n<p>Member ID {{member.Id}}</p>',            
        },

        bookWithDimmiURL :
        {
            name: 'bookWithDimmiURL',
            value: 'http://www.theunionhotel.com.au/dimmi/',
            defaultValue: 'http://www.theunionhotel.com.au/dimmi/',
            enabled: true                        
        },
  
        aboutMembershipHTML : 
        {
            name: "aboutMembershipHTML",
            value: "<p><img alt=\"\" class=\"full-image\" src=\"http://www.theunionhotel.com.au/wp-content/uploads/2014/09/rewards-poster.jpg\" /></p>\n\n<p>&nbsp;</p>\n",
            defaultValue: "<p><img alt=\"\" class=\"full-image\" src=\"http://www.theunionhotel.com.au/wp-content/uploads/2014/09/rewards-poster.jpg\" /></p>\n\n<p>&nbsp;</p>\n",
        },

        contactPhoneNumber :
        {
            name: "contactPhoneNumber",
            value: "82312144",
            defaultValue: "82312144"
        },

        aboutVenueHTML :
        {
            name: "aboutVenueHTML",
            value: "<h1 style=\"color:black !important\">Union Hotel</h1><p>&nbsp; 70 Waymouth Streett<br />\n&nbsp; Adelaide SA 5000</p>\n\n<p>&nbsp; Phone: +61 8 8231 2144<br />\n&nbsp; Fax: +61 8 8410 1804</p>\n\n<p>&nbsp;&nbsp;<a href=\"mailto:info@theunionhotel.com.au\">info@theunionhotel.com.au</a></p>\n",
            defaultValue: "<h1 style=\"color:black !important\">Union Hotel</h1><p>&nbsp; 70 Waymouth Streett<br />\n&nbsp; Adelaide SA 5000</p>\n\n<p>&nbsp; Phone: +61 8 8231 2144<br />\n&nbsp; Fax: +61 8 8410 1804</p>\n\n<p>&nbsp;&nbsp;<a href=\"mailto:info@theunionhotel.com.au\">info@theunionhotel.com.au</a></p>\n",
        }
    };

    String.prototype.replaceAll = function(str1, str2) {
        return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g,"\\$&"),("g")),(typeof(str2)=="string")?str2.replace(/\$/g,"$$$$"):str2);
    };

    function regenerateCss() {
        var css = customisationsCss;
        for (var idx in customisations) {
            var field = customisations[idx];
            css = css.replaceAll('$'+field.name, field.value);
        }
        return css;
    }

    function notify() {
        $rootScope.$emit(customisationDataUpdatedEvent, this.data);
    }

    var service = {

        customisations: customisations,

        get: function() {
            var snapshot = LocalStorageService.get('snapshot');

            if (snapshot === null)
            {
                this.resetToDefaults(false);
                snapshot = LocalStorageService.get('snapshot');
            }
            return snapshot;
        },
        
        setFieldValue: function(fieldName, value) {
            if (value === "" || value === null)
                value = service.customisations[fieldName].defaultValue;
            service.customisations[fieldName].value = value;
        },

        getFieldValue: function(fieldName) {
            if (fieldName in service.customisations)
                return service.customisations[fieldName].value;
            else
                return null;
        },

        // Iterates through the given customisation object fields
        // and checks if we know how to turn any of them 
        // into CSS snippets, then returns the CSS.
        getCss: function() {
            return regenerateCss();
        },

        set: function(newCustomisations, css) {

            for (var idx in newCustomisations)
            {
                if (idx in service.customisations)
                    service.setFieldValue(idx, newCustomisations[idx]);
            }

            notify();

            $rootScope.snapshot = {
                content:"null", 
                "customisationsCss":service.getCss(), 
                "customCss": css, 
                "customisations":service.customisations
            };
     
            LocalStorageService.set('snapshot', $rootScope.snapshot);

            $rootScope.$digest();
        },

        initialise: function() {
            
            $rootScope.snapshot = LocalStorageService.get('snapshot');

            if ($rootScope.snapshot === null)
            {
                this.resetToDefaults(false);
            }
  
            notify();

        },

        resetToDefaults: function(digest) {
            for (var idx in service.customisations)
                service.setFieldValue(idx, service.customisations[idx].defaultValue);

            $rootScope.snapshot = {
                content:"null", 
                "customisationsCss":service.getCss(), 
                "customCss": "", 
                "customisations":service.customisations
            };
            
            LocalStorageService.set('snapshot', $rootScope.snapshot);

            notify();   

            if (digest)
                $rootScope.$digest();         
        },

        subscribe: function(scope, eventName, callback) {
              var handler = $rootScope.$on(eventName, callback);
              $rootScope.$on('$destroy', handler);
        },
    };

    // 
    // Initialise the service to it's defaults
    //
    //service.resetToDefaults(false);
    service.initialise();

    // Watch for changes from Firebase
    var path = "";
    if (ionic.Platform.isIOS() || ionic.Platform.isAndroid())
        path = 'projectData/' + projectTag + '/publicReadOnly/';
    else
        path = 'projectData/' + projectTag + '/admin';

    path = path + "/design/app";

    firebase.database().ref(path).on('value', function(snap) {
        console.log(snap.val());
        if (snap.val() != null && 'customisations' in snap.val())
            service.set(snap.val().customisations,snap.val().css);
        else
            service.resetToDefaults(true);
    }); 

    // if the design is removed by any chance, revert to defaults
    firebase.database().ref('projectData/' + projectTag + '/publicReadOnly/').on('child_removed', function(snap,prevChildName) {
        if (prevChildName==='design') {
            service.resetToDefaults(true);
        }
    });

    return service;
}]);

